var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEwinRacingOdds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/40x40px/eWin-index/Racing/odds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Asset",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "odds",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.0000667,28.5938507 C40.0000667,30.0263047 31.0460517,31.1877013 20.0000333,31.1877013 C8.95468159,31.1877013 0,30.0263047 0,28.5938507 C0,27.1613966 8.95468159,26 20.0000333,26 C31.0460517,26 40.0000667,27.1613966 40.0000667,28.5938507",
    id: "Fill-7",
    fill: "#D8D8D8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3C01B",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 0,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DAA02D",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 3.1440559,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3C01B",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 6.28811179,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DAA02D",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 9.43216769,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3C01B",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 12.5762236,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DAA02D",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 15.7202795,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3C01B",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 18.8643354,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#DAA02D",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 22.0083913,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F3C01B",
    fillRule: "nonzero",
    x: 21.6191371,
    y: 25.1524472,
    width: 15.6953097,
    height: 3.1440559,
    rx: 0.9695
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6F0FA",
    fillRule: "nonzero",
    x: 2.78476548,
    y: 7.86013974,
    width: 21.1886681,
    height: 21.2223773,
    rx: 2.6181
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4F72B7",
    fillRule: "nonzero",
    x: 8,
    y: 13,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4F72B7",
    fillRule: "nonzero",
    x: 16,
    y: 13,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4F72B7",
    fillRule: "nonzero",
    x: 12,
    y: 17,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4F72B7",
    fillRule: "nonzero",
    x: 8,
    y: 21,
    width: 3,
    height: 3,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#4F72B7",
    fillRule: "nonzero",
    x: 16,
    y: 21,
    width: 3,
    height: 3,
    rx: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEwinRacingOdds);
export default __webpack_public_path__ + "static/media/ewin_racing_odds.f5a240ab32fd1e2a86bdb763d03a5420.svg";
export { ForwardRef as ReactComponent };